<div class="foa-loader-holder">
  <div class="loader-bubbles">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>